import { useTranslation } from 'react-i18next';

// components
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import StaffListComponent from '../../../components/Persons/StaffList/Staff.List.Component';

export const StaffListPage = () => {
  //useTranslation()
  const [t] = useTranslation();

  /* Sin solapas: quedó sólo el listado de miembros.
     Los tipos de identificación y los tipos de relación se sacaron por ahora;
     sus componentes siguen en su lugar —IdentifierTypes.List.Component y
     RelationshipTypes.List.Component— así que volver a ofrecerlos es reponer el
     Pivot con sus dos PivotItem. */
  return (
    <>
      <PageHeader
        title={t('staffListPage.title', { defaultValue: 'Staff' })}
        subtitle={t('staffListPage.subtitle', {
          defaultValue: 'Administración de las personas que integran el staff'
        })}
      />
      <div className="Content">
        <div className="Section">
          <StaffListComponent />
        </div>
      </div>
    </>
  );
};

export default StaffListPage;
